import { useAnalytics } from '@praxis/analytics/client'
import { useAuth } from '@praxis/component-auth'

export const useFirefly = () => {
  const { sendClickEvent } = useAnalytics()
  const auth = useAuth()

  const createClickEvent = (type, key, value, lanId) => {
    const strVal = String(value)
    return {
      event: {
        id: type + ':' + key,
        value: strVal,
      },
      client: {
        employee_login_id: lanId,
      },
    }
  }
  const handleTrackCustomEvent = (type, key, value) => {
    const lanId = auth?.session?.userInfo?.lanId
    sendClickEvent(key, createClickEvent(type, key, value, lanId))
  }
  return {
    handleTrackCustomEvent,
  }
}
